var app = angular.module('leonardo');

var MessageService = function(BaseRestService, RestangularProvider) {
  var service = new BaseRestService('notifications');

  service.getMessagesOverview = function(params) {
    return RestangularProvider.all('notifications').customGET('overview', params);
  };

  return service;
};

app.factory('MessageService', ['BaseRestService', 'Restangular', MessageService]);
